var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransit2On(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2451 8.29297V20.0791C32.8373 20.0281 32.4219 20 32 20C31.7044 20 31.412 20.0148 31.123 20.04V10.6279L17.6836 16.9316V33.5645L22.1309 31.3457C22.2644 32.0213 22.4911 32.6899 22.7686 33.3311L16.6221 36.3984L0 28.1055V8.29297L16.6221 0L33.2451 8.29297ZM2.12207 26.8604L15.5615 33.5645V16.9316L10.2568 14.4434V20.2451L10.0723 20.0664C10.0118 20.0054 9.95159 19.9431 9.89258 19.8799L9.54785 19.4941C9.43857 19.3674 9.26552 19.143 9.07715 18.9053C8.79067 18.5437 8.46539 18.1539 8.25879 18.0391L8.22656 18.0215C8.16282 17.994 8.09107 17.9788 8.01367 17.9736C8.0093 17.9733 8.00441 17.9729 8 17.9727C7.42342 17.9432 6.52757 18.4467 6.0127 18.4912V12.4531L2.12207 10.6279V26.8604ZM11.1377 12.582L16.6221 15.1533L29.8994 8.92773L23.9893 5.97852L11.1377 12.582ZM3.34473 8.92773L7.02832 10.6553L20.0518 4.01367L16.6221 2.30371L3.34473 8.92773Z",
    fill: "#196BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30.0772C40 34.5381 32 42 32 42C32 42 24 34.5381 24 30.0772C24 25.6163 27.5817 22 32 22C36.4183 22 40 25.6163 40 30.0772Z",
    fill: "#F00000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 4,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit2On);
export default __webpack_public_path__ + "static/media/transit2On.10c42bb31b2ee6866df3958ea64807df.svg";
export { ForwardRef as ReactComponent };